"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoType = void 0;
var PromoType;
(function (PromoType) {
    PromoType[PromoType["Standalone"] = 0] = "Standalone";
    PromoType[PromoType["NextUp"] = 1] = "NextUp";
    PromoType[PromoType["TradeIn"] = 2] = "TradeIn";
    PromoType[PromoType["Regular"] = 3] = "Regular";
})(PromoType = exports.PromoType || (exports.PromoType = {}));
//# sourceMappingURL=Device.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/wireless-ui/models/Device.js
// module id = 941
// module chunks = 8